// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"60896a6a","166":"60896a6a","264":"6bc6d6db","352":"6bc6d6db","702":"60896a6a","767":"6bc6d6db"}[chunkId] + ".chunk.css";
};